import { render, staticRenderFns } from "./materialInput.vue?vue&type=template&id=7b36254a&scoped=true"
import script from "./materialInput.vue?vue&type=script&lang=js"
export * from "./materialInput.vue?vue&type=script&lang=js"
import style0 from "./materialInput.vue?vue&type=style&index=0&id=7b36254a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b36254a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b36254a')) {
      api.createRecord('7b36254a', component.options)
    } else {
      api.reload('7b36254a', component.options)
    }
    module.hot.accept("./materialInput.vue?vue&type=template&id=7b36254a&scoped=true", function () {
      api.rerender('7b36254a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/materialInput.vue"
export default component.exports